import React from 'react';
import FAQCollapse from './Components/FAQCollapse';
import styles from './styles.module.scss';
import chunk from 'lodash/chunk';
import { data } from './constants';

const FAQ = () => {
  const [itemCollapsed, setItemCollapsed] = React.useState(undefined);

  const toggleCollapse = id => {
    if (itemCollapsed === id) setItemCollapsed(undefined);else setItemCollapsed(id);
  };

  const rowPerColumn = Math.floor(data.length / 1);
  const columnData = chunk(data, rowPerColumn);

  const renderColumnData = data => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, data.map(rowData => /*#__PURE__*/React.createElement("div", {
      className: styles.columnCollapse,
      key: rowData.id
    }, /*#__PURE__*/React.createElement(FAQCollapse, {
      data: rowData,
      isCollapsed: itemCollapsed === rowData.id,
      toggleCollapse: () => toggleCollapse(rowData.id)
    }))));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "FAQ's")), /*#__PURE__*/React.createElement("div", {
    className: styles.containerFAQ
  }, columnData.map(data => /*#__PURE__*/React.createElement("div", {
    key: data.map(row => row.id).join('-'),
    className: styles.column
  }, renderColumnData(data))))));
};

export default FAQ;